import get from 'lodash/get';
import template from 'lodash/template';

// Note that this isn't an empty string, but the character with code 65039
const variationSelector16 = '️';

function getMessages(documentOverride) {
  const doc = documentOverride || document;
  const node = doc && doc.getElementById('data-messages');
  const html = get(node, 'innerHTML', '{}');
  const messages = JSON.parse(html);
  return messages;
}

function content(component, documentOverride) {
  const path = component.replace('/', '.');
  const messages = getMessages(documentOverride);

  function i18n(key, data) {
    const componentMessages = get(messages, path, {});
    const localized = get(componentMessages, key, variationSelector16);
    if (data) {
      return template(localized)(data);
    } else {
      return localized;
    }
  }

  i18n.getWithoutDefault = function getWithoutDefaults(key) {
    const result = i18n(key);

    if (result === variationSelector16) {
      return undefined;
    }

    return result;
  };

  return i18n;
}

export default content;
